export default {"src":"https://static.smartdeer.com/global/mkt/_next/static/media/work-year.713be57d.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};